import apiClient from '../client';
import type { Complaint, UpdateComplaintStatusPayload, AssignComplaintPayload } from '@/types';

const BASE = '/admin/complaints';

export const complaintsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Complaint[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: Complaint }>(`${BASE}/${id}`).then((r) => r.data.data),

  updateStatus: (id: number, payload: UpdateComplaintStatusPayload) =>
    apiClient.patch<{ data: Complaint }>(`${BASE}/${id}/status`, payload).then((r) => r.data.data),

  assign: (id: number, payload: AssignComplaintPayload) =>
    apiClient.patch<{ data: Complaint }>(`${BASE}/${id}/assign`, payload).then((r) => r.data.data),

  resolve: (id: number, resolution_note: string) =>
    apiClient.patch<{ data: Complaint }>(`${BASE}/${id}/resolve`, { resolution_note }).then((r) => r.data.data),

  statusCounts: () =>
    apiClient.get<{ data: { open: number; in_progress: number; resolved: number; closed: number } }>(`${BASE}/counts`).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`${BASE}/${id}`),
};

